import React from 'react'
import {
    BlocParcoursComparer,
    BlocParcoursEstimer,
    Conditionnal,
    Header,
} from '../ImportAll'

export default function Vue0() {
    return (
        <div>
            <Header subTitle="Vous avez un projet, on s’occupe du prêt ! " />
            <div className="Container">
                <Conditionnal
                    linked_data_id="tech_source_neuf"
                    isEqualTo
                    targetDataValueCompare={true}
                >
                    <BlocParcoursEstimer
                        key="key2"
                        linked_data_id="tech_type_action_depart"
                        linked_data_value="estimer"
                        targetView={1}
                        large
                    />
                </Conditionnal>
                <Conditionnal
                    linked_data_id="tech_source_neuf"
                    isNotEqualTo
                    targetDataValueCompare={true}
                >
                    <BlocParcoursComparer
                        key="key1"
                        linked_data_id="tech_type_action_depart"
                        linked_data_value="comparer"
                        targetView={17}
                    />
                    <BlocParcoursEstimer
                        key="key2"
                        linked_data_id="tech_type_action_depart"
                        linked_data_value="estimer"
                        targetView={1}
                    />
                </Conditionnal>
            </div>
        </div>
    )
}
